import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.restoreFocus = false
    this.beforeRender = this.rememberFocus.bind(this)
    this.afterLoad = this.restoreFrameFocus.bind(this)
    this.element.addEventListener("turbo:before-frame-render", this.beforeRender)
    this.element.addEventListener("turbo:frame-load", this.afterLoad)
  }

  disconnect() {
    this.element.removeEventListener("turbo:before-frame-render", this.beforeRender)
    this.element.removeEventListener("turbo:frame-load", this.afterLoad)
  }

  rememberFocus() {
    const active = document.activeElement
    this.restoreFocus = Boolean(active && active !== this.element && this.element.contains(active))
  }

  restoreFrameFocus() {
    if (!this.restoreFocus) return

    this.restoreFocus = false
    this.element.querySelector("[data-content-patient-library--results-focus-target='focus']")?.focus({ preventScroll: true })
  }
}
